import Image from 'app/Components/Shared/Image/image';
import React ,{useState} from 'react'
import {Row, Col} from 'reactstrap';
import {validateFileAndSendReport} from './selfCareUploadFileSlice';
import {connect} from 'react-redux';
import {recaptcha} from '../../../utilities/recaptcha/recaptcha';
import TextInput from '../../Shared/TextInput/TextInput';
import './SelfCareUploadFile.scss'
import Config from '../../../Config';
import Loader from '../../Shared/LocalLoader/LocalLoader';
import FileInput from '../../Shared/FileInput/FileInput';
function SelfCareUploadFile(props) {
          const actionsList = props.iContent.uploadFileActions.expandedValue;
          const [action,setAction]= useState('');
          const [mail ,setMail]= useState('');
          const [fileName, setFileName] = useState("");
          const [extension, setExtension] = useState("");
          const [converted, setConverted] = useState("");
          const [mailError, setMailError] = useState('');
          const [fileExtensionError, setFileExtensionError] = useState('');
          const [validationFileMsg, setValidationFileMsg] = useState('');

      async function uploadFile(e) {
          const file = e.target.files[0];
          setFileName(file.name.split('.')[0]);
          setExtension(file.type.split('/')[1]);
          let fileConverted = await toBase64(file);
          setConverted(fileConverted.replace(`data:${file.type};base64,`, ""))
      }


  const mailValidation = () => {
    const regMail =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regMail.test(String(mail).toLowerCase());
  }

  async function sendFile(){
        recaptcha()
        .then(async (token) => {
          if (token != '' && token != null) {
          await props.validateFileAndSendReport({extension , converted, token , action , mail, fileName, orgId: props.selectedHetPay})
          .then((res) => {
          res.payload.error ?
               setValidationFileMsg('הקובץ אינו תקין '):setValidationFileMsg('הקובץ נשלח בהצלחה');
          })}
        })
    }

    async function validateDetails()
    {
      const isValidMail = mailValidation();
      const isValidFileExtension = extension == "csv";
      isValidMail ? setMailError('') : setMailError( 'כתובת אימייל לא תקינה');
      isValidFileExtension ? setFileExtensionError('') :setFileExtensionError('אנא טען קובץ csv בלבד');
      isValidMail && isValidFileExtension && sendFile();
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    return (
        <div className='selfCare-container'>
            <Col>
              <Row className='self-care-row-header'>
                <h4 className='header'>
                {props.iContent.title.value}
                </h4>
              </Row>

              <Row className='self-care-action-row'>
               <div className='border'></div>
               {
                actionsList.map((act)=>{
                return( <div className='box-col'>
                        <div className='box' onClick={() => {setAction(act.actionName.value)}}>
                           <Image className='img' alt='action' width="60px" src={Config.epiBaseUrl + act.actionIcon.value?.url} />
                            <div className='txt'>{act.actionTitle.value}</div>
                         </div>
                  </div>)
                })
               }
            </Row>
                {action &&
                  <div className='input-container'>
                       <Col>
                          <div className='mt-3'>
                           <div className='field-wrapper'>
                            <TextInput
                                type='email'
                                placeholder='הכנס מייל לקבלת הדו"ח הסופי'
                                name='mailAddress'
                                value={mail}
                                onChange={(e) => {
                                  setMail(e.target.value);
                                  setMailError('');
                                 }}
                                 error={mailError}
                                    />
                              </div>
                            </div>
                            <div className='d-flex flex-column'>
                              <FileInput
                                id="fileInput"
                                onChange={(e)=>{
                                  uploadFile(e);
                                  setFileExtensionError('');
                                }}
                                filename ={fileName}
                                error={fileExtensionError}
                              />
                            </div>
                            <button  className='save-btn mt-3' onClick={()=>{validateDetails()}} > שלח </button>
                            <div className='mt-3'>
                            {!validationFileMsg && props.validationFile.isLoading?
                              <Loader/> :
                              <h4 className='validationFileMsg'>{validationFileMsg}</h4>
                             }
                          </div>
                      </Col>
                  </div>
                  }
              </Col>
        </div>
    )
}


  const mapStateToProps = (state) => {
    return{validationFile: state.SelfCareUploadFile,
           selectedHetPay: state.portalsBlock.selectedHetPay,
          };
  };

  const mapDispatchToProps = {
    validateFileAndSendReport,
  };

  export default connect(mapStateToProps, mapDispatchToProps)(SelfCareUploadFile);

